import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BaseApiTemplateService, Core2Config } from "../../../shared";
import { PostLineContainer } from "../../../../../../../models/mongodbSchema/aggregates";

@Injectable({providedIn: 'root'})
export class PostLineService extends BaseApiTemplateService<PostLineContainer>{    
    basePath: string;
    paginationPath:string;
    constructor(private http:HttpClient){
        super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'project-drive-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'project-drive-links';
    this.httpClient = http;
    }

    public fetchMedia(postLineUuid, apiVisa){
        let url = this.apiUrl + `/${postLineUuid}/media`;
        return this.httpClient
            .get(
                url,
                {
                    responseType: 'blob',
                    headers: new HttpHeaders({
                      'Content-Type': 'application/json',
                      'tenant-code': apiVisa.tenantCode,
                      'token': apiVisa.jwt_secret
                    })
                  }
            )
    }
}